import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Layout from "../layouts/Layout";
import { isAuthenticated, onAuthExpired } from "../apis/auth";

const ProtectedRoute = () => {
    const navigate = useNavigate();
    const [authed, setAuthed] = useState(isAuthenticated());

    useEffect(() => {
        // When the API interceptor sees a 401/419, drop the user back to login.
        const unsubscribe = onAuthExpired(() => {
            setAuthed(false);
            navigate("/", { replace: true });
        });
        return () => { unsubscribe(); };
    }, [navigate]);

    if (!authed) {
        return <Navigate to="/" replace />;
    }

    return (
        <Layout>
            <Outlet />
        </Layout>
    );
};

export default ProtectedRoute;